
import React, { useState, useEffect } from 'react';
import {
  ArrowRight, Zap, Shield, Play, Eye, Star, TrendingUp, Search, BarChart, Cpu, CreditCard, Settings, PieChart, RotateCcw,
  BarChart3, SlidersHorizontal, FileBarChart, PlugZap, Banknote, ShoppingCart, Truck,
  Video, Camera, VideoOff, Users, LocateFixed, FileText, ShieldCheck, Cloud, Server, ClipboardList, Lightbulb
} from 'lucide-react';
import Header from "./header";
import Footer from "./footer";
const HubLiveLanding = () => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const [animationStep, setAnimationStep] = useState(0);
  const [scrollY, setScrollY] = useState(0);
  const [isVisible, setIsVisible] = useState({});
  const [activeFeature, setActiveFeature] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentTitle, setCurrentTitle] = useState(0);


  const [currentTitleIndex, setCurrentTitleIndex] = useState(0);

  const [imageLoaded, setImageLoaded] = useState(false);

  const titles = [
    "RECON KEY FEATURES",
    // "SEAMLESS PAYMENTS",
    // "SECURE TRANSACTIONS",
    // "SMART COLLECTIONS"
  ];

  const usecase = [
    {
      id: 1,
      // title: "Instant, Paperless Verification.",
      description: "Instant, Paperless Verification",
      imagePath: "/images/sms-notification.png", // Add your image path here
      position: "left"
    },
    {
      id: 2,
      // title: "Liveness Verification",
      description: "Secured & Encrypted Interaction",
      imagePath: "/images/liveness-verification.png", // Add your image path here
      position: "left"
    },
    {
      id: 3,
      // title: "Location Verification",
      description: "Scalable by Design",
      imagePath: "/images/location-verification.png", // Add your image path here
      position: "left"
    },
    {
      id: 4,
      // title: "KYC List Verification",
      description: "Fraud Prevention with Live Proof",
      imagePath: "/images/kyc-verification.png", // Add your image path here
      position: "right"
    },
    {
      id: 5,
      // title: "OCR Integration",
      description: "Fast & Seamless User Experience",
      imagePath: "/images/ocr-integration.png", // Add your image path here
      position: "right"
    },
    {
      id: 6,
      // title: "Third-Party API Verification",
      description: "Cloud-Based & Always Available",
      imagePath: "/images/api-verification.png", // Add your image path here
      position: "right"
    }
  ];

  const leftFeatures = usecase.filter(usecase => usecase.position === "left");
  const rightFeatures = usecase.filter(usecase => usecase.position === "right");

  const features = [
    {
      icon: <Video className="w-7 h-7" />,
      title: "Live Video Collaboration",
      desc: "High-quality, real-time video powered by WebRTC for seamless agent-to-client interactions.",
      color: "blue"
    },
    {
      icon: <Camera className="w-7 h-7" />,
      title: "Snapshots & File Uploads",
      desc: "Capture live snapshots or upload supporting documents/images directly within the session.",
      color: "purple"
    },
    {
      icon: <VideoOff className="w-7 h-7" />,
      title: "Short Video Recording",
      desc: "Record key parts of the conversation for compliance, audits, or proof of interaction.",
      color: "red"
    },
    {
      icon: <Users className="w-7 h-7" />,
      title: "Multi-Participant Support",
      desc: "Add multiple members into a live session for group collaboration or approvals.",
      color: "green"
    },
    {
      icon: <LocateFixed className="w-7 h-7" />,
      title: "Live Location Tracking",
      desc: "Verify user authenticity by capturing live geolocation during the session.",
      color: "yellow"
    },
    {
      icon: <FileText className="w-7 h-7" />,
      title: "OCR & Document Verification",
      desc: "Extract and validate information instantly from IDs or uploaded documents.",
      color: "indigo"
    },
    {
      icon: <ShieldCheck className="w-7 h-7" />,
      title: "Encrypted & Secure",
      desc: "End-to-end encrypted communication with secure data storage for maximum privacy.",
      color: "teal"
    },
    {
      icon: <Cloud className="w-7 h-7" />,
      title: "Cloud-Based Platform",
      desc: "No heavy installations needed—VideoTech runs on the cloud for anytime, anywhere access.",
      color: "cyan"
    },
    {
      icon: <Server className="w-7 h-7" />,
      title: "Scalable Infrastructure",
      desc: "Easily handle multiple concurrent sessions with enterprise-grade reliability.",
      color: "orange"
    },
    {
      icon: <ClipboardList className="w-7 h-7" />,
      title: "Audit Trail & Compliance",
      desc: "Automatic recording of sessions, snapshots, and documents ensures a full compliance log.",
      color: "rose"
    }
  ];

  const merchant = [
    {
      icon: <ShieldCheck className="w-7 h-7" />,
      title: "Unmatched Security",
      desc: "End-to-end encrypted sessions, secure document handling, and fraud-resistant verification.",
      color: "yellow"
    },
    {
      icon: <Zap className="w-7 h-7" />,
      title: "Faster, Smarter, Better",
      desc: "Instant KYC, real-time collaboration, and seamless user experience—because time is money.",
      color: "blue"
    },
    {
      icon: <Cloud className="w-7 h-7" />,
      title: "Cloud-Powered & Scalable",
      desc: "From startups to enterprises, scale effortlessly with our reliable, cloud-first infrastructure.",
      color: "purple"
    },
    {
      icon: <Video className="w-7 h-7" />,
      title: "More Than Video Calls",
      desc: "Snapshots, document uploads, short recordings, multi-participant support, and live location tracking—all in one platform.",
      color: "gray"
    },
    {
      icon: <ClipboardList className="w-7 h-7" />,
      title: "Compliance Made Simple",
      desc: "Audit-ready logs, automated records, and regulatory support for industries that demand trust.",
      color: "red"
    },
    {
      icon: <Lightbulb className="w-7 h-7" />,
      title: "Future-Ready Innovation",
      desc: "AI-driven fraud detection and constant feature upgrades keep you ahead of the curve.",
      color: "teal"
    }
  ];


  return (
    <div className="min-h-screen">
      <Header />
      <section
        className="py-12 px-4 sm:px-6 lg:px-8 bg-slate-50"
        style={{
          background: `linear-gradient(135deg, 
          rgba(59, 130, 246, 0.1) 0%, 
          rgba(147, 51, 234, 0.1) 50%, 
          rgba(219, 39, 119, 0.1) 100%
        )`,
          fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div
            className="absolute top-20 left-10 w-32 h-32 bg-gradient-to-br from-blue-200/30 to-purple-200/30 rounded-full animate-pulse transform rotate-45"
            style={{ transform: `translateY(${scrollY * 0.1}px) rotate(45deg)` }}
          ></div>
          <div
            className="absolute top-40 right-20 w-24 h-24 bg-gradient-to-br from-indigo-200/40 to-blue-200/40 rounded-lg animate-bounce transform rotate-12"
            style={{ animationDelay: '1s', transform: `translateY(${scrollY * 0.15}px) rotate(12deg)` }}
          ></div>
          <div
            className="absolute bottom-20 left-20 w-16 h-16 bg-gradient-to-br from-purple-200/30 to-pink-200/30 rounded-full animate-pulse transform -rotate-12"
            style={{ animationDelay: '2s', transform: `translateY(${scrollY * 0.2}px) rotate(-12deg)` }}
          ></div>
          <div
            className="absolute bottom-40 right-10 w-20 h-20 bg-gradient-to-br from-cyan-200/40 to-blue-200/40 rounded-lg animate-bounce transform rotate-45"
            style={{ animationDelay: '0.5s', transform: `translateY(${scrollY * 0.12}px) rotate(45deg)` }}
          ></div>
        </div>
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            {/* Left Content */}
            <div className="space-y-6">
              <div className="space-y-4">
                {/* <div className="flex justify-start">
                  <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 py-2 rounded-full text-sm font-medium shadow-lg">
                    <Star className="w-4 h-4" />
                    <div className="text-center leading-tight">
                      Reconciliation with AI</div>
                  </div>
                </div> */}

                <div className="flex justify-start">
                  <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 py-1.5 rounded-full text-xs sm:text-sm font-medium shadow-md max-w-full">
                    <Star className="w-3 h-3 flex-shrink-0" aria-hidden="true" />
                    <p className="whitespace-normal leading-tight">
                      Next-Gen Video KYC Solution
                    </p>
                  </div>
                </div>

                {/* <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight tracking-tight">
                  <div className="text-slate-800 font-bold mb-2">
                    From Complexity to Clarity
                  </div>
                  <div className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent font-semibold leading-snug">
                    Automating Reconciliation Across Industries
                  </div>
                </h1> */}

                <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight tracking-tight">
                  <div className="text-gray-800 font-semibold">
                    VIDEOTECH SOLUTION
                  </div>
                  <div className="text-lg sm:text-xl lg:text-1.5xl font-medium bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 bg-clip-text text-transparent mt-1">
                    Connect, Capture, Verify in Real-Time.
                  </div>
                </h1>

                <p className="text-base text-slate-600 leading-relaxed font-normal">
                  Empower your agents with live snapshots, document uploads, OCR verification, and session recording—while clients experience smooth, secure video interactions.
                  At Video Technology, we don’t just connect people—we redefine trust in digital interactions.
                  Our platform blends cutting-edge technology with secure, scalable, and human-centered design, giving businesses the confidence to verify, collaborate, and grow without barriers.

                </p>

                {/* Key Features */}
                {/* <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-4">
                  <div className="flex items-center gap-2">
                    <Cpu className="w-5 h-5 text-green-600" />
                    <span className="text-sm text-slate-700 font-medium">Automated Matching</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Search className="w-5 h-5 text-blue-600" />
                    <span className="text-sm text-slate-700 font-medium">Anomaly Detection</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <BarChart className="w-5 h-5 text-purple-600" />
                    <span className="text-sm text-slate-700 font-medium">Real-Time Insights</span>
                  </div>
                </div> */}

              </div>
            </div>

            {/* Right Content - Video Placeholder */}
            <div className="relative">
              <div className="relative rounded-xl overflow-hidden shadow-2xl bg-black/20 backdrop-blur-sm border border-white/10">
                <video
                  className="w-full h-auto rounded-xl"
                  autoPlay
                  muted
                  loop
                  playsInline
                  src="./videoconf.mp4"
                  preload="metadata"
                >
                  <source src="/path/to/your/video.mp4" type="video/mp4" />
                  <source src="/path/to/your/video.webm" type="video/webm" />
                  Your browser does not support the video tag.
                </video>

                {/* Optional overlay for styling */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none rounded-xl"></div>
              </div>

              {/* Decorative elements */}
              <div className="absolute -top-4 -right-4 w-20 h-20 bg-purple-400/30 rounded-full blur-xl"></div>
              <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-blue-400/30 rounded-full blur-lg"></div>
            </div>
          </div>
        </div>
      </section>


      {/* <section className="py-8 px-4 sm:px-6 lg:px-8 bg-slate-50">
        <div className="max-w-5xl mx-auto">
          <div className="relative group">
            <img
              src="/reconwithAI.png"
              alt="Payment Gateway Platform Screenshot"
              className={`w-full h-auto rounded-xl shadow-lg transition-all duration-300 hover:shadow-xl ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
              onLoad={() => setImageLoaded(true)}
            />
            <div className="absolute -top-3 -right-3 w-16 h-16 bg-gradient-to-br from-slate-400/15 to-slate-500/15 rounded-full blur-lg"></div>
            <div className="absolute -bottom-4 -left-4 w-20 h-20 bg-gradient-to-br from-slate-500/15 to-slate-600/15 rounded-full blur-lg"></div>
          </div>
        </div>
      </section> */}

      <section className="py-12 bg-slate-50 px-4 sm:px-6 lg:px-8" >
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-4">
            <h2 className="block bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent text-2xl sm:text-3xl lg:text-4xl font-bold mb-3 animate-pulse hover:animate-none transition-all duration-500 hover:scale-105 cursor-default">
              {/* Complete Payment Gateway */}
              CHALLENGES WITH TRADITIONAL VIDEO SOLUTIONS ?
            </h2>

          </div>
          {/* Image Container */}
          <div className="relative group w-full">
            <div className="relative bg-white rounded-xl overflow-hidden transition-all duration-300">
              <img
                src="/vt.png" // Replace with your image path
                alt="Payment Gateway Platform Screenshot"
                className={`w-full h-auto max-h-100 object-cover transition-all duration-300 ${imageLoaded ? 'opacity-100' : 'opacity-0'
                  }`}
                onLoad={() => setImageLoaded(true)}
              />
            </div>
            {/* Decorative Elements */}
            <div className="absolute -top-3 -right-3 w-16 h-16 bg-gradient-to-br from-slate-400/15 to-slate-500/15 rounded-full blur-lg"></div>
            <div className="absolute -bottom-4 -left-4 w-20 h-20 bg-gradient-to-br from-slate-500/15 to-slate-600/15 rounded-full blur-lg"></div>
          </div>
        </div>
      </section>


      <div className="py-16 px-4 bg-slate-50">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 animate-fade-in-up">
            <span className="inline-block animate-pulse bg-gradient-to-r from-blue-600 via-purple-600 to-cyan-600 bg-clip-text text-transparent">
              HOW WE SOLVE THE CHALLENGES
            </span>
          </h2>

          {/* Animations */}
          <style jsx>{`
      @keyframes fade-in-up {
        0% {
          opacity: 0;
          transform: translateY(20px);
        }
        100% {
          opacity: 1;
          transform: translateY(0);
        }
      }

      .animate-fade-in-up {
        animation: fade-in-up 1s ease-out;
      }
    `}</style>

          {/* Grid with 3 Columns */}
          <div className="grid md:grid-cols-[3fr_4fr_3fr] gap-6 mt-12 items-center">
            {/* Left Features */}
            <div className="space-y-6">
              {leftFeatures.map((usecase, index) => (
                <div
                  key={usecase.id}
                  className="flex items-center justify-end group animate-fade-in-up"
                  style={{ animationDelay: `${index * 0.2}s`, animationFillMode: 'both' }}
                >
                  <div className="mb-10 text-right mr-4 bg-white rounded-lg p-4 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 max-w-sm">
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">
                      {usecase.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {usecase.description}
                    </p>
                  </div>
                  <div className="mb-10 w-12 h-12 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <img
                      src={usecase.imagePath}
                      alt={usecase.title}
                      className="w-8 h-8 object-contain filter brightness-0 invert"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                      }}
                    />
                    <div className="hidden w-6 h-6 bg-white rounded opacity-90"></div>
                  </div>
                  <div className="w-15 h-0.5 bg-gradient-to-r from-blue-400 to-transparent ml-2"></div>
                </div>
              ))}
            </div>

            {/* Center Device Mockup */}
            <div className="flex flex-col items-center justify-center relative z-10">
              {/* Laptop */}
              <div className="relative flex justify-center items-center p-2 h-full w-full">
                <img
                  src="videotech4.png"
                  alt="Dashboard Image"
                  className="w-full h-auto object-contain border-4 border-gray-800"
                />
              </div>

              {/* Mobile */}
              <div className="bg-gray-800 rounded-xl p-1 shadow-lg">
                <div className="bg-gradient-to-b from-purple-400 to-pink-500 rounded-lg h-32 w-16 flex flex-col items-center justify-center">
                  <div className="w-1.5 h-1.5 bg-white rounded-full mb-1"></div>
                  <div className="bg-white rounded p-1 flex-1 w-full mx-0.5 flex flex-col justify-center items-center">
                    <div className="w-6 h-6 bg-gradient-to-r from-blue-400 to-purple-500 rounded mb-0.5"></div>
                    <div className="w-8 h-0.5 bg-gray-300 rounded mb-0.5"></div>
                    <div className="w-6 h-0.5 bg-gray-200 rounded"></div>
                  </div>
                  <div className="w-5 h-0.5 bg-white rounded-full mt-0.5"></div>
                </div>
              </div>
            </div>

            {/* Right Features */}
            <div className="space-y-6">
              {rightFeatures.map((feature, index) => (
                <div
                  key={feature.id}
                  className="flex items-center group animate-fade-in-up"
                  style={{ animationDelay: `${(index + 3) * 0.2}s`, animationFillMode: 'both' }}
                >
                  <div className="mb-10 w-12 h-12 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <img
                      src={feature.imagePath}
                      alt={feature.title}
                      className="w-8 h-8 object-contain filter brightness-0 invert"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                      }}
                    />
                    <div className="hidden w-6 h-6 bg-white rounded opacity-90"></div>
                  </div>
                  <div className="mb-10 text-left ml-4 bg-white rounded-lg p-4 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 max-w-sm">
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>

      {/* Cards Sections */}

      <div className="py-16 px-4 bg-slate-50">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 animate-fade-in-up">
            <span className="inline-block animate-pulse bg-gradient-to-r from-blue-600 via-purple-600 to-cyan-600 bg-clip-text text-transparent">
              ADVANCED FEATURES
            </span>{" "}
            {/* <span className="inline-block animate-bounce-slow">

                            Payment Gateway Suite?
                        </span> */}
          </h2>

          <style jsx>{`
                    @keyframes fade-in-up {
                        0% {
                            opacity: 0;
                            transform: translateY(20px);
                        }
                        100% {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }

                    @keyframes bounce-slow {
                        0%, 20%, 50%, 80%, 100% {
                            transform: translateY(0);
                        }
                        40% {
                            transform: translateY(-3px);
                        }
                        60% {
                            transform: translateY(-1px);
                        }
                    }

                    .animate-fade-in-up {
                        animation: fade-in-up 1s ease-out;
                    }

                    .animate-bounce-slow {
                        animation: bounce-slow 2s infinite;
                        animation-delay: 0.5s;
                    }
                `}</style>

          <div className="grid md:grid-cols-5 gap-6 mt-12">
            {features.map((feature, index) => (
              <div
                key={index}
                className="p-6 bg-white border border-gray-200 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 flex flex-col items-center text-center group hover:scale-[1.02] transition-transform"
              >
                <div className={`mb-4 p-4 rounded-full bg-${feature.color}-100 text-${feature.color}-600`}>
                  {feature.icon}
                </div>
                <h3 className="text-base font-semibold text-slate-800 mb-2">{feature.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>

        </div>
      </div>

      <div className="py-16 px-4 bg-slate-50">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 animate-fade-in-up">
            <span className="inline-block animate-pulse bg-gradient-to-r from-blue-600 via-purple-600 to-cyan-600 bg-clip-text text-transparent">
              Why Choose Our
            </span>{" "}
            <span className="inline-block animate-bounce-slow">

              Video Technology?
            </span>
          </h2>

          <style jsx>{`
                    @keyframes fade-in-up {
                        0% {
                            opacity: 0;
                            transform: translateY(20px);
                        }
                        100% {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }

                    @keyframes bounce-slow {
                        0%, 20%, 50%, 80%, 100% {
                            transform: translateY(0);
                        }
                        40% {
                            transform: translateY(-3px);
                        }
                        60% {
                            transform: translateY(-1px);
                        }
                    }

                    .animate-fade-in-up {
                        animation: fade-in-up 1s ease-out;
                    }

                    .animate-bounce-slow {
                        animation: bounce-slow 2s infinite;
                        animation-delay: 0.5s;
                    }
                `}</style>

          <div className="grid md:grid-cols-6 gap-6 mt-12">
            {merchant.map((feature, index) => (
              <div key={index} className="text-center group hover:transform hover:scale-105 transition-all duration-300">
                <div className={`w-16 h-16 bg-${feature.color}-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:shadow-lg transition-shadow duration-300`}>
                  <div className={`text-${feature.color}-600`}>
                    {feature.icon}
                  </div>
                </div>
                <h3 className="font-semibold text-slate-900 mb-2 text-sm md:text-base">{feature.title}</h3>
                <p className="text-xs md:text-sm text-slate-600 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Call to Action - Dark Theme */}
      <section className="py-8 bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 relative overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full animate-pulse"></div>
          <div className="absolute top-40 right-20 w-24 h-24 bg-white/5 rounded-lg animate-bounce transform rotate-45" style={{ animationDelay: '1s' }}></div>
          <div className="absolute bottom-20 left-20 w-16 h-16 bg-white/10 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
          <div className="absolute bottom-40 right-10 w-20 h-20 bg-white/5 rounded-lg animate-bounce transform -rotate-12" style={{ animationDelay: '0.5s' }}></div>

          <div className="absolute top-1/4 left-1/4 animate-float">
            <Zap className="w-8 h-8 text-white/20" />
          </div>
          <div className="absolute top-1/3 right-1/3 animate-float" style={{ animationDelay: '1.5s' }}>
            <Shield className="w-6 h-6 text-white/20" />
          </div>
          <div className="absolute bottom-1/3 left-1/3 animate-float" style={{ animationDelay: '3s' }}>
            <TrendingUp className="w-7 h-7 text-white/20" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          {/* Main Content */}
          <div className="space-y-4 animate-fadeInUp">
            <h2 className="text-2xl sm:text-3xl lg:text-3xl font-bold text-white leading-tight animate-slideInLeft">
              Revolutionizing Video Technology for a Smarter, Connected World.
            </h2>
          </div>

          {/* CTA Button - Smaller and More Compact */}
          <div className="mt-6 animate-fadeInUp" style={{ animationDelay: '1.2s' }}>
            <button
              className="group relative inline-flex items-center gap-3 bg-gradient-to-r from-white to-blue-50 text-blue-700 px-8 py-3 rounded-xl font-semibold text-lg hover:from-yellow-300 hover:to-orange-300 hover:text-gray-900 transform hover:scale-105 transition-all duration-500 shadow-xl hover:shadow-yellow-300/50"
              onClick={() => {
                window.location.href = '/contact';
              }}
            >
              <Play className="w-5 h-5 group-hover:animate-bounce" />
              <span>Get In Touch</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />

              {/* Button Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </button>
          </div>
        </div>

        <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          33% { transform: translateY(-10px) rotate(5deg); }
          66% { transform: translateY(5px) rotate(-5deg); }
        }
        
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(-50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slideInUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-float {
          animation: float 4s ease-in-out infinite;
        }
        
        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInLeft {
          animation: slideInLeft 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInRight {
          animation: slideInRight 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInUp {
          animation: slideInUp 0.8s ease-out forwards;
          opacity: 0;
        }
      `}</style>
      </section>
      <Footer />
    </div>
  );
};

export default HubLiveLanding;